"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const silo_types_1 = require("./silo.types");
const app_types_1 = require("pages/app.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataBrand: [],
    dataDropdown: [],
    mutationMode: false,
    dataItem: {
        id: '',
        inEdit: false,
        modified_by: '',
        brand1_name: '',
        brand2_name: '',
        brand3_name: '',
        isDisabled: false,
        checkpoint_id: '',
        checkpoint_name: '',
        brand2_disabled: false,
        brand3_disabled: false,
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'checkpoint_name', dir: 'asc' }]
    }
};
const siloReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [silo_types_1.siloConfigTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [silo_types_1.siloConfigTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [silo_types_1.siloConfigTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        const newDatabrand = state.dataBrand.filter(x => {
            return x.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand1_name) &&
                x.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand2_name) &&
                x.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.brand3_name);
        });
        const defaultBrand = [{
                id: '',
                code: '',
                name: '-',
                is_active: true,
                created_by: '',
                modified_by: '',
                created_date: new Date(),
                modified_date: new Date()
            }];
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataDropdown: defaultBrand.concat(newDatabrand), dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [silo_types_1.siloConfigTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [silo_types_1.siloConfigTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isError,
            errorCode,
            errorMessage, isSuccess: false });
    },
    [silo_types_1.siloConfigTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [silo_types_1.siloConfigTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [silo_types_1.siloConfigTypes.ON_ENTER_EDIT_CLICK]: (state, action) => {
        const { dataGrid, dataItem, dataBrand, mutationMode } = action.payload;
        const brand_default = {
            id: '',
            code: '',
            name: '',
            is_active: true,
            created_by: '',
            created_date: new Date(),
            modified_by: '',
            modified_date: new Date()
        };
        const brand1_data = dataBrand.find(item => item.name === dataItem.brand1_name) || brand_default;
        const brand2_data = dataBrand.find(item => item.name === dataItem.brand2_name) || brand_default;
        const brand3_data = dataBrand.find(item => item.name === dataItem.brand3_name) || brand_default;
        const newDataDropdown = state.dataBrand.filter(item => {
            return item.name !== dataItem.brand1_name &&
                item.name !== dataItem.brand2_name &&
                item.name !== dataItem.brand3_name;
        });
        const newDataItem = Object.assign(Object.assign({}, dataItem), { brand1_data,
            brand2_data,
            brand3_data, brand1_name: brand1_data.name, brand2_name: brand2_data.name, brand3_name: brand3_data.name });
        return Object.assign(Object.assign({}, state), { dataGrid,
            mutationMode, dataItem: mutationMode ? newDataItem : initialState.dataItem, dataDropdown: mutationMode
                ? [Object.assign(Object.assign({}, brand_default), { id: '', name: '-' })].concat(newDataDropdown)
                : state.dataDropdown });
    },
    [silo_types_1.siloConfigTypes.SET_DATA_BRAND]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataBrand: action.payload.dataBrand, dataDropdown: action.payload.dataBrand });
    }
});
exports.default = siloReducer;
